// src/components/Locales.jsx (Sesuaikan letak foldernya)
import PropTypes from 'prop-types';
import { useEffect, useState, useMemo, useCallback } from 'react';
import { IntlProvider } from 'react-intl';
import useConfig from 'hooks/useConfig';
import { transformModulesToMenu } from '../utils/tranformModuleToMenu';

import { translations } from '../utils/i18n';

const loadLocaleData = (locale) => {
  if (translations[locale]) {
    return Promise.resolve({ default: translations[locale] });
  }

  switch (locale) {
    case 'fr':
      return import('../utils/locales/fr.json');
    case 'ro':
      return import('../utils/locales/ro.json');
    default:
      return Promise.resolve({ default: translations['en'] });
  }
};

export default function Locales({ children }) {
  const { i18n } = useConfig();
  const [messages, setMessages] = useState();
  const localeDataPromise = useMemo(() => loadLocaleData(i18n), [i18n]);

  const mergeMenuTranslations = useCallback((baseMessages) => {
    try {
      const raw = localStorage.getItem('dataModules');
      const modules = raw ? JSON.parse(raw) : null;
      if (Array.isArray(modules) && modules.length > 0) {
        const { translations } = transformModulesToMenu(modules);
        Object.keys(translations || {}).forEach((k) => {
          if (!baseMessages[k]) baseMessages[k] = translations[k];
        });
        return baseMessages;
      }

      const prev = localStorage.getItem('menu_translations');
      const parsed = prev ? JSON.parse(prev) : null;
      if (parsed && typeof parsed === 'object') {
        Object.keys(parsed).forEach((k) => {
          if (!baseMessages[k]) baseMessages[k] = parsed[k];
        });
      }

      return baseMessages;
    } catch (err) {
      console.warn('Locales: gagal merge menu translations', err);
      return baseMessages;
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    localeDataPromise
      .then((d) => {
        if (!mounted) return;
        const base = { ...(d.default || {}) };
        const merged = mergeMenuTranslations(base);
        setMessages(merged);
      })
      .catch((err) => {
        console.error('Failed to load locale data', err);
      });

    return () => {
      mounted = false;
    };
  }, [localeDataPromise, mergeMenuTranslations]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'dataModules' || e.key === 'menu_translations') {
        loadLocaleData(i18n).then((d) => {
          const base = { ...(d.default || {}) };
          const merged = mergeMenuTranslations(base);
          setMessages(merged);
        });
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [i18n, mergeMenuTranslations]);

  return (
    <>
      {messages && (
        <IntlProvider
          locale={i18n}
          defaultLocale="en"
          messages={messages}
          onError={(err) => {
            if (err && err.code === 'MISSING_TRANSLATION') return;
            console.error(err);
          }}
        >
          {children}
        </IntlProvider>
      )}
    </>
  );
}

Locales.propTypes = { children: PropTypes.node };
